import { useTranslation } from 'hooks/useTranslation'
import { ScoopServeBannerRoot, Tagline } from './ScoopServeBanner.styles'

export const ScoopServeBanner = () => {
  const { t } = useTranslation()

  return (
    <ScoopServeBannerRoot>
      <Tagline>{t('products-v2:freeze-dried-raw-nuggets.simple-banner.tagline')}</Tagline>
    </ScoopServeBannerRoot>
  )
}

ScoopServeBanner.displayName = 'ScoopServeBanner'
